import { render } from "./CityDetail.vue?vue&type=template&id=c838aa3a"
import script from "./CityDetail.vue?vue&type=script&lang=js"
export * from "./CityDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__